<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" text="cancelShipment" />
      </v-col>
    </v-row>

    <v-container fluid v-if="dataItems.length">
      <v-col
        cols="12"
        sm="10"
        md="10"
        v-for="(item, index) in dataItems"
        :key="index"
        class="px-1 py-1 mx-auto"
      >
        <v-card
          class="mx-auto rounded-lg"
          outlined
          style="border: 1.5px solid; overflow: hidden; gap: 4px"
          :style="{ borderColor: site.color }"
        >
          <v-container>
            <div class="d-flex" style="gap: 12px">
              <div
                class="d-flex justify-center align-center"
                style="width: 100px; min-width: 100px"
              >
                <v-img
                  :cover="true"
                  :aspect-ratio="1"
                  width="100%"
                  :lazy-src="require('@/assets/images/image.png')"
                  :src="item.image_url"
                  style="border-radius: 8px"
                >
                </v-img>
              </div>
              <div class="d-flex flex-column justify-center">
                <div class="my-0">
                  <p
                    class="text-start my-0"
                    :style="{ color: site.color }"
                    style="font-size: 12px"
                  >
                    {{ item.name }}
                  </p>
                </div>
                <div v-if="item.delivery_status == 'cancel'">
                  <p
                    class="text-start my-1"
                    style="font-size: 12px; color: red"
                  >
                    {{ $t("statusDeliveryCancel") }}
                  </p>
                </div>
              </div>
            </div>
          </v-container>
        </v-card>
      </v-col>
    </v-container>

    <div v-if="!dataItems.length">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner">{{ $t("waitingLoad") }}...</div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Axios from "@/config/customer-service";
import { mapState } from "vuex";

import HeaderTextBg from "../../../components/headerTextBg.vue";

export default {
  data: () => ({
    data: [],
    group: null,
    model: null,
    dataItems: [],
    item: "",
    next_page_url: "",
    infiniteId: +new Date(),
    copyAlert: false,
  }),
  components: {
    InfiniteLoading,
    HeaderTextBg,
  },
  created() {},
  methods: {
    changeStatus(item) {
      this.status = item.toString();
      this.initialize();
    },
    infiniteHandler($state) {
      Axios.get("reward/listDeliveryReward", {
        params: {
          status_code: 3,
          cursor: this.next_page_url,
        },
      }).then(({ data }) => {
        if (data.data.data.length) {
          let has_more = data.data.has_more;
          this.dataItems = this.dataItems.concat(data.data.data);
          if (!has_more) {
            $state.complete();
            return;
          } else {
            this.next_page_url = data.data.next_page_url.split("=")[1];
            $state.loaded();
          }
        } else {
          $state.complete();
        }
      });
    },
    initialize() {
      this.dataItems = [];
      this.next_page_url = "";
      this.infiniteId += 1;
    },

    changeLang(val) {
      return this.$t(val);
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
};
</script>

<style scoped>
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  opacity: 1 !important;
  -webkit-box-shadow: rgb(0 0 0 / 24%) 0 3px 8px;
  box-shadow: 0 3px 8pxrgba (0, 0, 0, 0.24);
  border-radius: 10px !important;
  height: 80px;
  min-width: 95px;
  border-radius: 10px;
}

.v-slide-group__content {
  justify-content: center !important;
}

.v-btn-toggle--group > .v-btn.v-btn {
  background-color: white !important;
  border-color: transparent;
}
</style>
